<template>
  <div 
    v-if="visible"
    id="asset-card-row">
    <div class="row">
      <div class="col-sm-12">
        <div v-for="(asset, index) in assets" :key="index" :class="assetClassName">
          <component v-bind:is="'card-asset'" :asset="asset" @deleteAsset="deleteAsset" :imagePath="asset.url" :visible="asset.visible"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardAsset from "@/components/shared/inputs/AssetCard";

export default {
  name: "CardAssetRow",
  components: {
    "card-asset": CardAsset
  },
  props: {
    assets: {
      type: Array,
      required: true
    },
    assetClassName: {
      type: String,
      default: "col-sm-6"
    },
    spanClassName: {
      type: String,
      required: false
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    deleteAsset(id) {
      this.$emit("deleteAsset", id);
    }
  }
};
</script>

<style lang="scss">
#asset-card-row {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/AssetCardRow.vue